export const defaultFaqField = [
  "question",
  "answer",
  "faq_type",
  "path",
  "createdAt",
  "action",
];


export const FAQ_SORT_KEYS = {
  faqs: ["question", "answer", "faq_type", "createdAt"],
};
